/**
 * Electron ko'prigi.
 *
 * Panel BRAUZERDA ham ishlaydi: u yerda `window.uyda` bo'lmaydi
 * va qurilmaga bog'liq tugmalar umuman ko'rsatilmaydi. Shuning
 * uchun har bir chaqiruvdan oldin ko'prik borligi tekshiriladi —
 * `undefined` ga murojaat qilish butun sahifani yiqitardi.
 */

export interface PrinterList {
  documents: Array<{ name: string; displayName: string; description: string }>;
  labels: string[];
}

export interface PrintResult {
  printed: boolean;
  reason?: string;
}

interface UydaBridge {
  /** Oyna foni shaffofmi — tizim materiali yoqilganmi. */
  translucent: boolean;
  /** Tizim oynasi tugmalari sahifa ustida turadimi (macOS). */
  overlayTitleBar: boolean;
  saveFile(suggestedName: string, contentBase64: string): Promise<{ saved: boolean; path?: string }>;
  info(): Promise<{ version: string; platform: string; isDev: boolean; translucent: boolean }>;
  printers(): Promise<PrinterList>;
  print(deviceName?: string): Promise<PrintResult>;
  printLabel(printer: string, contentBase64: string): Promise<PrintResult>;
}

declare global {
  interface Window {
    uyda?: UydaBridge;
  }
}

/** Ko'prik mavjudmi — ya'ni ilova Electron ichida ishlayaptimi. */
export function hasBridge(): boolean {
  return typeof window !== "undefined" && typeof window.uyda === "object";
}

export function bridge(): UydaBridge | undefined {
  return typeof window === "undefined" ? undefined : window.uyda;
}

/**
 * Oyna fonini interfeysga e'lon qiladi.
 *
 * React yuklanishidan OLDIN chaqiriladi: keyin chaqirilsa, bir
 * lahza qattiq fon ko'rinib, so'ng shaffofga o'tardi.
 *
 * Brauzerda hech narsa qilinmaydi — u yerda oyna ortida ish
 * stoli emas, veb-sahifa turadi va shaffof fon oq varaqqa
 * aylanardi.
 */
export function applyShellMode(): void {
  if (typeof document === "undefined") return;

  const api = bridge();
  if (!api) return;

  if (api.translucent) document.documentElement.dataset.shell = "translucent";
  if (api.overlayTitleBar) document.documentElement.dataset.titlebar = "overlay";
}
